import { Component, OnInit, Input } from '@angular/core';
import { IQualification } from '@ebb-v2/ebb-integration';

@Component({
    selector: 'hom-drawer',
    templateUrl: './drawer.component.html',
    styleUrls: ['./drawer.component.scss'],
    standalone: false
})
export class DrawerComponent implements OnInit {
  @Input() qualification: { saveQualification: IQualification };

  constructor() { }

  ngOnInit(): void { }

}
